import {makeAutoObservable} from "mobx";
import {toast} from 'react-toastify';
import environment from '../environments';
import {apiFetch, notifyError} from '../api';

const emptySticker = () => ({landingpageInputs: [], landingpageValues: []});

class StickerStore
{
    stickerList = [];
    stickerMap = [];
    sticker = emptySticker();
    /* ID of the record in sticker, so a different record never shows stale data */
    loadedId = null;
    stickerPhotos = [];
    start = 0;
    limit = 100;
    searchTerm = "";

    /* Endpoints */
    detailRoute = "/stickers";
    dataEndpoint = environment.API_HOST + "/stock/list";
    searchEndpoint = environment.API_HOST + "/stock/search";
    /* Table configuration */
    sortBy = "granted";
    sortOrder = "desc";
    tableColumns = [
        {name: "ID", field: "identifier", sortable: true},
        //{name: "Titel", field: "title"},
        //{name: "URL", field: "url"},
        {name: "Anzahl Scans", field: "scans", type: "text", sortable: true},
        {name: "Erstellt am", field: "created", type: "date", sortable: true},
        {name: "Aktualisiert am", field: "updated", type: "date", sortable: true},
        {name: "Aktiviert", field: "granted", type: "date", sortable: true},
        {name: "Produkt", field: "icon_key", type: "image", sortable: false}
    ];

    constructor()
    {
        makeAutoObservable(this)
    }

    getStickerList()
    {
        apiFetch(this.dataEndpoint + "?start=" + this.start + "&limit=" + this.limit + "&sortBy=" + this.sortBy + "&sortOrder=" + this.sortOrder)
            .then((json) =>
            {
                this.stickerList = json.data
            })
            .catch((error) =>
            {
                notifyError(error);
                return error;
            })
    }

    getStickerMap()
    {
        apiFetch(environment.API_HOST + "/stock/map")
            .then((json) =>
            {
                this.stickerMap = json.data
            })
            .catch((error) =>
            {
                notifyError(error);
                return error;
            })
    }

    searchSticker()
    {
        /* Start again on the first page */
        this.start = 0;

        if (this.searchTerm && this.searchTerm.length > 0)
        {
            const term = this.searchTerm;
            apiFetch(this.searchEndpoint + "?term=" + encodeURIComponent(term))
                .then((json) =>
                {
                    if (term === this.searchTerm)
                    {
                        this.stickerList = json.data
                    }
                })
                .catch((error) =>
                {
                    notifyError(error);
                })

        } else
        {
            this.getStickerList();
        }
    }

    /* Searches stickers without touching the sticker list, e.g. for selection fields. */
    findStickers(term)
    {
        return apiFetch(this.searchEndpoint + "?term=" + encodeURIComponent(term))
            .then((json) => json.data || [])
            .catch((error) =>
            {
                notifyError(error);
                return [];
            });
    }

    getSticker(id)
    {
        if (this.loadedId !== id)
        {
            this.sticker = emptySticker();
            this.loadedId = id;
        }

        apiFetch(environment.API_HOST + "/stock/" + id)
            .then((json) =>
            {
                /* Ignore responses for a record that is no longer open */
                if (id !== this.loadedId)
                {
                    return;
                }

                this.sticker = json.data[0]

                /* Boolean pre-assignment */
                this.sticker.active = this.sticker.active || 0;
                this.sticker.tracking_active = this.sticker.tracking_active || 0;
                this.sticker.lp_active = this.sticker.lp_active || 0;
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    saveSticker(id)
    {
        var payload = {
            active: this.sticker.active,
            url: this.sticker.url,
            lp_active: this.sticker.lp_active,
            tracking_active: this.sticker.tracking_active,
            landingpageValues: this.sticker.landingpageValues
        }

        payload = JSON.stringify(payload);

        apiFetch(environment.API_HOST + "/stock/" + id, {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json"
            },
            body: payload
        })
            .then((json) =>
            {
                toast.success("Sticker erfolgreich gespeichert.");
                this.getSticker(id);
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    resetSticker(id)
    {
        apiFetch(environment.API_HOST + "/stock/" + id, {
            method: 'DELETE',
            headers: {
                "Content-Type": "application/json"
            }
        })
            .then((json) =>
            {
                toast.success("Sticker erfolgreich zurückgesetzt.");
                this.getSticker(id);
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    getStickerPhotos(id)
    {
        apiFetch(environment.API_HOST + "/stock/" + id + "/photos")
            .then((json) =>
            {
                this.stickerPhotos = json.data[0]
            })
            .catch((error) =>
            {
                notifyError(error);
            })
    }

    sort(column)
    {
        /* Start again on the first page */
        this.start = 0;

        this.sortBy = column;

        if (this.sortOrder === 'asc')
        {
            this.sortOrder = 'desc';
        } else
        {
            this.sortOrder = 'asc';
        }

        this.getStickerList();
    }

    nextPage()
    {
        this.start = this.start + this.limit
        this.getStickerList();
    }

    previousPage()
    {
        if (this.start - this.limit >= 0)
        {
            this.start = this.start - this.limit
            this.getStickerList();
        }
    }
}

const stickerStore = new StickerStore();
export default stickerStore;
